/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Deep_Elk_RoamInputs */

const en_warm_deep_elk_roam = /** @type {(inputs: Warm_Deep_Elk_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Round Name`)
};

const de_warm_deep_elk_roam = /** @type {(inputs: Warm_Deep_Elk_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rundenname`)
};

/**
* | output |
* | --- |
* | "Round Name" |
*
* @param {Warm_Deep_Elk_RoamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_deep_elk_roam = /** @type {((inputs?: Warm_Deep_Elk_RoamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Deep_Elk_RoamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_deep_elk_roam(inputs)
	return de_warm_deep_elk_roam(inputs)
});